import { BoltIcon } from "@heroicons/react/24/solid";

export const NewBadge = () => (
  <span className="inline-flex items-center px-2.5 py-1 rounded-full text-xs font-base bg-yellow-400 text-gray-950">
    Ny funktion
    <BoltIcon className="h-4 w-4 ml-1 text-gray-950" />
  </span>
);
